'use client';

import { useRouter } from 'next/navigation';
import React from 'react';

/**
 * Public landing page (Design System v3 — Teal -> Blue brand refresh).
 */
export default function Page() {
  const router = useRouter();

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#000000',
        color: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1.25rem 2rem',
          borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
          backgroundColor: 'rgba(10, 15, 26, 0.75)',
          backdropFilter: 'blur(12px)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img
            src="/images/esabha-logo.png"
            alt="E-Sabha Logo"
            style={{ height: '46px', width: 'auto', objectFit: 'contain' }}
          />
        </div>

        <button
          onClick={() => router.push('/login')}
          style={{
            backgroundColor: '#F59E0B',
            color: '#000000',
            fontWeight: 700,
            fontSize: '0.875rem',
            padding: '8px 18px',
            borderRadius: '20px',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 2px 10px rgba(245, 158, 11, 0.3)',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <span>👑</span> Host Sign In
        </button>
      </header>

      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3rem 1rem',
          textAlign: 'center',
          backgroundImage:
            'radial-gradient(ellipse at 50% 20%, rgba(0, 63, 178, 0.25) 0%, rgba(0, 199, 156, 0.08) 35%, transparent 70%)',
        }}
      >
        <div style={{ maxWidth: '620px' }}>
          <h1
            style={{
              fontSize: '2.75rem',
              fontWeight: 800,
              margin: '0 0 1rem 0',
              letterSpacing: '-0.03em',
              background: 'linear-gradient(135deg, #00C79C 0%, #00A895 35%, #0191AA 65%, #003FB2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Secure, Instant Video Conferencing
          </h1>
          <p style={{ fontSize: '1.1rem', color: '#94A3B8', margin: 0, lineHeight: 1.6 }}>
            Enterprise-grade, low-latency video meetings powered by LiveKit SFU. Join meetings instantly
            without accounts or software downloads.
          </p>

          <div
            style={{
              marginTop: '2.5rem',
              backgroundColor: '#0A0F1A',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '16px',
              padding: '1.75rem',
              textAlign: 'left',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.45)',
            }}
          >
            <div style={{ fontSize: '0.95rem', fontWeight: 600, color: '#FFFFFF', marginBottom: '10px' }}>
              Joining a Meeting?
            </div>
            <ul
              style={{
                margin: 0,
                paddingLeft: '1.2rem',
                color: '#94A3B8',
                fontSize: '0.9rem',
                lineHeight: 1.8,
              }}
            >
              <li>Click the shareable meeting link provided by your organizer.</li>
              <li>Links look like <code style={{ color: '#00C79C', backgroundColor: '#1A2333', padding: '2px 6px', borderRadius: '4px' }}>/join/abc-defg-hij</code></li>
              <li>Enter your display name and join with video and crystal-clear audio immediately!</li>
            </ul>
          </div>
        </div>
      </main>

      <footer
        style={{
          textAlign: 'center',
          padding: '1.5rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.08)',
          color: '#64748B',
          fontSize: '0.875rem',
          backgroundColor: '#000000',
        }}
      >
        Organizing a meeting?{' '}
        <a href="/login" style={{ color: '#F59E0B', textDecoration: 'none', fontWeight: 600 }}>
          Sign in as host 👑
        </a>
      </footer>
    </div>
  );
}
